import Vue from 'vue';
export const RemoveFieldBus = new Vue();